import React, { useState } from "react"

import { LogInButton } from "./LogInButton"
import { LogOutButton } from "./LogOutButton"
import Popup from "./Popup"

const LogInOutButton = ({ explorer, popup = new Popup(), microcopy }) => {
  popup.init({ useState, explorer })

  return (
    <span>
      {explorer.accessToken.loggedIn() ? (
        <LogOutButton
          microcopy={microcopy}
          handleLogout={() => explorer.accessToken.logout()}
        />
      ) : (
        <LogInButton
          microcopy={microcopy}
          waiting={popup.waiting}
          handleLogin={() => popup.open()}
        />
      )}
    </span>
  )
}

export default LogInOutButton
